import { CurriculumEventBase } from '../curriculumEventBase';

type SessionTimelineSection = {
  media?: {
    _type: 'image' | 'video';
    name: string;
  };
};

type SessionTimelineSegment = {
  activity: string;
  group: string;
  leader: string;
  name: string;
  isFlex: boolean;
  enabled: boolean;
  sections: SessionTimelineSection[];
};

type SegmentToggledEventPayload = {
  eventSubType: 'Session Timeline Segment Toggled';
  activity: string;
  group: string;
  leader: string;
  name: string;
  isFlex: boolean;
  enabled: boolean;
  images?: string[];
  videos?: string[];
};

export class SegmentToggledEvent extends CurriculumEventBase<SegmentToggledEventPayload> {
  public static format(segment: SessionTimelineSegment): SegmentToggledEventPayload {
    const getSectionMediaItemNames = (
      sections: SessionTimelineSection[] | undefined,
      mediaType: 'image' | 'video'
    ): string[] => {
      if (!sections) return [];

      return sections
        .map(section => (section.media?._type === mediaType ? section.media.name : null))
        .filter(Boolean) as string[];
    };

    return {
      eventSubType: 'Session Timeline Segment Toggled',
      activity: segment.activity,
      group: segment.group,
      leader: segment.leader,
      name: segment.name,
      isFlex: segment.isFlex,
      enabled: segment.enabled,
      images: getSectionMediaItemNames(segment.sections, 'image'),
      videos: getSectionMediaItemNames(segment.sections, 'video'),
    };
  }
}
